import { useTransactionCodeConfigList } from "gen/endpoints/transactions/transactions";
import { TransactionCodeConfigListClassification } from "gen/model/transactionCodeConfigListClassification";
import { TransactionCodeConfigListSubClassification } from "gen/model/transactionCodeConfigListSubClassification";
import { TransactionTypeEnum } from "gen/model/transactionTypeEnum";

const useOffsetCodeConfigs = (fundFamilyId: string) => {
  const res = useTransactionCodeConfigList(fundFamilyId, {
    classification: TransactionCodeConfigListClassification.expenses,
    transaction_type: TransactionTypeEnum.portfolio,
    sub_classification: TransactionCodeConfigListSubClassification.fee_offset,
  });

  return {
    ...res,
    data: res.data,
  };
};

export default useOffsetCodeConfigs;
